import React from 'react';
import { useSelector } from 'react-redux';
import { LostRealtimeSocketMessageModal } from '@shoflo/polymer/components/LostRealtimeSocketMessageModal/LostRealtimeSocketMessageModal';
import { LOST_REALTIME_SOCKET_CONNECTION } from 'constants/ModalTypes';

function LostRealtimeSocketMessage() {
  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === LOST_REALTIME_SOCKET_CONNECTION
  );

  return <LostRealtimeSocketMessageModal isOpen={isOpen} />;
}

export default LostRealtimeSocketMessage;
